import React, { useCallback } from "react";
import PurchaseDocDetails from "../../_components/Purchasing/PurchaseDocDetails";
import { getPurchaseDebitNoteById, updatePurchaseDebitNote, createPurchaseDebitNote } from "../../_services/finance.service";
import { getPurchaseInvoices, getPurchaseInvoiceById } from "../../_services/purchase.service";
import { getSuppliers } from "../../_services/contact.service";
import { companyProfileService } from "../../_services/companyProfile.service";

// same supplier helpers as PurchaseOrderDetails.jsx (copy them)
let supplierCache = {};
async function getCachedSupplier(supplierName) {
    if (!supplierName) return [];
    if (supplierCache[supplierName]) return supplierCache[supplierName];
    const res = await getSuppliers({ pageSize: 1000, page: 1, search: supplierName, searchType: "name" });
    supplierCache[supplierName] = res?.data || [];
    return supplierCache[supplierName];
}

async function fetchSupplierNames() {
    const res = await getSuppliers({ pageSize: 1000, page: 1 });
    const names = (res?.data || [])
        .filter(r => ((r.status || r.Status || "").toLowerCase() === "active"))
        .map(r => r.name)
        .filter(Boolean);
    return [...new Set(names)].sort();
}

async function fetchContactPersons(supplierName) {
    if (!supplierName) return [];
    const data = await getCachedSupplier(supplierName);
    return data
        .filter(r => r.name === supplierName && !!r.attention && ((r.status || r.Status || "").toLowerCase() === "active"))
        .map(r => r.attention ?? "")
        .filter(Boolean)
        .filter((v, i, a) => a.indexOf(v) === i);
}

async function fetchSupplierDetails(supplierName, contactPerson = "") {
    if (!supplierName) return {};
    const data = await getCachedSupplier(supplierName);
    const rows = data.filter(r => r.name === supplierName);
    const first = rows[0];
    if (!first) return {};

    const base = {
        supplierAddress: first.billingAddress || first.billing_address || first.address || "",
        supplierShippingAddress: first.shippingAddress || first.shipping_address || "",
    };

    if (!contactPerson) return base;

    const match = rows.find(r => (r.attention || "") === contactPerson) || first;
    return {
        ...base,
        paymentTerms: match.creditTerms || match.credit_terms || "",
        phoneNumber: match.phoneNumber || match.phone_number || "",
    };
}

export default function PurchaseDebitNoteDetails() {
    const fetchCompProfile = useCallback(() => companyProfileService.getProfile(), []);

    return (
        <PurchaseDocDetails
            docType="Purchase Debit Note"
            basePath="/finance/purchase-debit-notes"
            fetchById={getPurchaseDebitNoteById}
            updateItem={updatePurchaseDebitNote}
            createItem={createPurchaseDebitNote}
            fetchSupplierNames={fetchSupplierNames}
            fetchContactPersons={fetchContactPersons}
            fetchSupplierDetails={fetchSupplierDetails}
            fetchCompanyProfile={fetchCompProfile}
            fetchPiList={getPurchaseInvoices}
            fetchPiById={getPurchaseInvoiceById}
            taxRate={0}
            searchable={false}
            searchSource="RM"
        />
    );
}